import { Inject, Injectable, OnDestroy } from '@angular/core';
import {
  MSAL_GUARD_CONFIG,
  MsalGuardConfiguration,
  MsalService,
} from '@azure/msal-angular';
import { BrowserAuthError, SilentRequest } from '@azure/msal-browser';
import { PolicyService } from '@horizon/core';
import { UrlBuilder } from 'http-url-builder';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class AuthorizationService implements OnDestroy {
  private readonly destroy$ = new Subject<void>();

  constructor(
    @Inject(MSAL_GUARD_CONFIG)
    private msalGuardConfig: MsalGuardConfiguration,
    private authService: MsalService,
    private policyService: PolicyService
  ) {
    this.policyService.setAppEnvironment({
      policyServiceUrl: new UrlBuilder(environment.apim.baseUrl)
        .addPath(environment.apim.apiSlugs.policyService)
        .build(),
    });
  }

  public checkAuth(): void {
    const authRequest: SilentRequest = {
      ...this.msalGuardConfig.authRequest,
      scopes: environment.authScopes,
    };
    this.authService
      .acquireTokenSilent(authRequest)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        () => this.setCurrentUserId.bind(this),
        (err) => {
          const noAccountError =
            err instanceof BrowserAuthError &&
            err.errorCode === 'no_account_error';
          if (!noAccountError) {
            console.error(err);
          }
          this.setCurrentUserId();
        }
      );
  }

  /* login(): void {
    if (this.msalGuardConfig.authRequest) {
      this.authService
        .loginPopup({ ...this.msalGuardConfig.authRequest } as PopupRequest)
        .subscribe(
          () => {
            this.setCurrentUserId();
          },
          (error) => console.log(error)
        );
    } else {
      this.authService.loginPopup().subscribe(
        () => this.setCurrentUserId(),
        (error) => console.log(error)
      );
    }
  } */

  logout(): void {
    this.authService
      .logoutPopup({
        mainWindowRedirectUri: '/',
      })
      .subscribe(() => {
        localStorage.clear();
        sessionStorage.clear();
      });
  }

  setCurrentUserId(): void {
    const allAccounts = this.authService?.instance?.getAllAccounts();
    const localAccountId = allAccounts[0]?.localAccountId;
    const loginDisplay = allAccounts?.length > 0;

    if (loginDisplay && localAccountId) {
      localStorage.setItem('currentUserId', JSON.stringify(localAccountId));
      this.policyService.getCurrentUserPermissions();
    }
  }

  ngOnDestroy(): void {
    this.destroy$.next(undefined);
    this.destroy$.complete();
  }
}
